import { create } from 'zustand';

export const initialFormData = {
  isInfoValid: false,
  isImagesValid: false,

  province: '',
  district: '',
  ward: '',
  address: '',
  coordinates: '',
  name: '',
  category: '',
  serviceHoursFrom: '00:00',
  serviceHoursTo: '12:00',
  priceRangeFrom: '',
  description: '',
  contactName: '',
  contactEmail: '',
  contactPhone: '',

  nameEN: '',
  discoverCategories: [],
  descriptionEN: '',

  slug: '',
  discoverProvince: '',

  images: [],
};

const useDiscoveryCreateStore = create((set) => ({
  formData: {
    ...initialFormData,
  },
  setFormData: (formData) => set((prev) => ({
    ...prev,
    formData: { ...prev.formData, ...formData },
  })),
}));

export default useDiscoveryCreateStore;
